import { Routes, Route, Navigate, useLocation } from 'react-router'
import { MainLayout } from '@/layouts/AnalyticsMainLayout'
import { OverviewPage } from '@/features/overview/OverviewPage'
import { ServicesPage } from '@/features/services/ServicesPage'
import { LogsPage } from '@/features/logs/LogsPage'
import { KubernetesPage } from '@/features/kubernetes/KubernetesPage'
import { GpuPage } from '@/features/gpu/GpuPage'
import { GatewayPage } from '@/features/gateway/GatewayPage'
import { InfraAssetsPage } from '@/features/infra-assets/InfraAssetsPage'
import { UsageAggregatedPage } from '@/features/usage/UsageAggregatedPage'
import { UsagePerCustomerPage } from '@/features/usage/UsagePerCustomerPage'
import { AccountingRevenuePage } from '@/features/accounting/AccountingRevenuePage'
import { AccountingSpendPage } from '@/features/accounting/AccountingSpendPage'

function SearchPreservingRedirect({ to }: { to: string }) {
  const location = useLocation()
  return <Navigate to={`${to}${location.search}`} replace />
}

export function AppRouter() {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<Navigate to="/infrastructure" replace />} />

        {/* Infrastructure — platform internals */}
        <Route path="/infrastructure" element={<OverviewPage />} />
        <Route path="/infrastructure/services" element={<ServicesPage />} />
        <Route path="/infrastructure/logs" element={<LogsPage />} />
        <Route path="/infrastructure/kubernetes" element={<KubernetesPage />} />
        <Route path="/infrastructure/gpu" element={<GpuPage />} />
        <Route path="/infrastructure/gateway" element={<GatewayPage />} />
        <Route path="/infrastructure/assets" element={<InfraAssetsPage />} />

        {/* Usage */}
        <Route path="/usage/aggregated" element={<UsageAggregatedPage />} />
        <Route path="/usage/per-customer" element={<UsagePerCustomerPage />} />

        {/* Accounting */}
        <Route path="/accounting/revenue" element={<AccountingRevenuePage />} />
        <Route path="/accounting/spend" element={<AccountingSpendPage />} />

        {/* Back-compat redirects for the pre-/infrastructure paths */}
        <Route path="/services" element={<SearchPreservingRedirect to="/infrastructure/services" />} />
        <Route path="/logs" element={<SearchPreservingRedirect to="/infrastructure/logs" />} />
        <Route path="/kubernetes" element={<SearchPreservingRedirect to="/infrastructure/kubernetes" />} />
        <Route path="/gateway" element={<SearchPreservingRedirect to="/infrastructure/gateway" />} />

        <Route path="*" element={<Navigate to="/infrastructure" replace />} />
      </Route>
    </Routes>
  )
}
